import { Badge } from "@/components/ui/badge";
import { getPriorityColor } from "@/utils/complianceScore";
import type { ComplianceTask } from "@/utils/complianceScore";

interface PriorityIndicatorProps {
  priority: ComplianceTask['priority'];
  className?: string;
  showLabel?: boolean;
}

export function PriorityIndicator({ priority, className = "", showLabel = true }: PriorityIndicatorProps) {
  const colorClass = getPriorityColor(priority);
  const label = priority.toUpperCase();

  return (
    <Badge
      variant="outline"
      className={`${colorClass} ${className}`}
    >
      {showLabel && label}
    </Badge>
  );
}

